<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_attribute_type') || '属性类型'"
            prop="scmInputColumnName"
          >
            <el-select
              size="medium"
              v-model="formData.scmInputColumnName"
              :disabled="isViewDisabled"
              :placeholder="$l('INDEX.check_label_select_please') || '请选择'"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in scmDictionaryOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_category') || '厂商分类'"
            prop="scmCategoryCode"
          >
            <el-select
              size="medium"
              v-model="formData.scmCategoryCode"
              disabled
              :placeholder="$l('INDEX.check_label_select_please') || '请选择'"
              style="width: 100%"
              filterable
              clearable
            >
              <el-option
                v-for="item in scmCategoryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_attribute_type_display') || '属性类型名称'"
            prop="scmInputColumnDisplay"
          >
            <el-input
              v-model="formData.scmInputColumnDisplay"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              :disabled="isViewDisabled"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_sortorder') || '排序顺序'"
            prop="sortOrder"
          >
            <el-input
              v-model="formData.sortOrder"
              :disabled="isViewDisabled"
              maxlength="11"
              :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
              clearable
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item
            :label="$l('form_label_column_type') || '输入字段类型'"
            prop="scmInputColumnType"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              :disabled="isViewDisabled"
              v-model="formData.scmInputColumnType"
            >
              <el-radio label="input">{{
                $l('form_radio_text') || '文字'
              }}</el-radio>
              <el-radio label="select">{{
                $l('form_radio_option') || '选项'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
        <!-- <el-col :span="12">
          <el-form-item
            :label="$l('form_label_is_visible') || '是否显示'"
            prop="isVisible"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              :disabled="isViewDisabled"
              v-model="formData.isVisible"
            >
              <el-radio label="Y">{{ $l('form_radio_yes') || '是' }}</el-radio>
              <el-radio label="N">{{ $l('form_radio_no') || '否' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_is_multiSelect') || '是否可以多选'"
            prop="isMultiselect"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              :disabled="isViewDisabled"
              v-model="formData.isMultiselect"
            >
              <el-radio label="Y">{{ $l('form_radio_yes') || '是' }}</el-radio>
              <el-radio label="N">{{ $l('form_radio_no') || '否' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_is_required') || '是否必输项'"
            prop="isRequired"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              :disabled="isViewDisabled"
              v-model="formData.isRequired"
            >
              <el-radio label="Y">{{ $l('form_radio_yes') || '是' }}</el-radio>
              <el-radio label="N">{{ $l('form_radio_no') || '否' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_status') || '属性模版状态'"
            prop="scmInpTempStatus"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              disabled
              v-model="formData.scmInpTempStatus"
            >
              <el-radio label="Y">{{
                $l('form_radio_valid') || '有效'
              }}</el-radio>
              <el-radio label="N">{{
                $l('form_radio_invalid') || '无效'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="createDataDisabled">
          <div style="font-size: 14px; color: #717171;">
            <span
              >Create：{{
                formData.createByName ? formData.createByName : '--'
              }}
              at {{ formData.createDate ? formData.createDate : '--' }}</span
            >
            |
            <span
              >Modify：{{
                formData.modifyByName ? formData.modifyByName : '--'
              }}
              at {{ formData.modifyDate ? formData.modifyDate : '--' }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  props: {
    scmTemplateCode: String,
    scmCategoryCode: String
  },
  components: {},
  data() {
    let num = /^[+]{0,1}(\d+)$/ // 验证正整数
    let checkSortOrder = (rule, value, callback) => {
      if (value) {
        if (!num.test(value)) {
          callback(new Error('排序顺序应是正整数'))
        }
      }
      callback()
    }
    return {
      createDataDisabled: false,
      isViewDisabled: false,
      scmDictionaryOptions: [],
      scmCategoryOptions: [],
      formData: {
        scmCategoryCode: '',
        scmInputColumnName: '',
        scmInputColumnDisplay: '',
        scmInputColumnType: '',
        isMultiselect: '',
        isRequired: 'N',
        isVisible: 'Y',
        sortOrder: '',
        scmInpTempStatus: 'Y'
      },
      rules: {
        scmInputColumnName: [
          { required: true, message: '请选择厂商属性', trigger: 'blur' }
        ],
        scmCategoryCode: [
          { required: true, message: '请选择厂商分类', trigger: 'blur' }
        ],
        scmInputColumnType: [
          { required: true, message: '请选择输入字段类型', trigger: 'blur' }
        ],
        isVisible: [
          { required: true, message: '请选择是否显示', trigger: 'blur' }
        ],
        scmInputColumnDisplay: [
          { required: true, message: '请输入属性类型名称', trigger: 'blur' }
        ],
        sortOrder: [
          { required: false, validator: checkSortOrder, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.reset()
    this.getDate()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getDate() {
      console.log(this.scmTemplateCode)
      if (!this.scmTemplateCode) return
      this.$api
        .scmInputTemplateDetailApi({
          scmTemplateCode: this.scmTemplateCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    reset() {
      this.formData = {
        scmCategoryCode: this.scmCategoryCode,
        scmInputColumnName: '',
        scmInputColumnDisplay: '',
        scmInputColumnType: 'select',
        isMultiselect: 'N',
        isRequired: 'N',
        isVisible: 'Y',
        sortOrder: '',
        scmInpTempStatus: 'Y'
      }
      this.$refs.form.resetFields()
      this.loadSelect()
    },
    loadSelect() {
      this.$api
        .scmDictionaryOptionApi({})
        .then((res) => {
          this.scmDictionaryOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })
      this.$api
        .scmCategoryOptionApi({})
        .then((res) => {
          this.scmCategoryOptions = res.body.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .scmInputTemplateSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
